import { createSelector } from '@reduxjs/toolkit'

import { selectDownload } from './selectDownload'

// Format bytes to human-readable format (MB)
const formatBytes = (bytes: number): string => {
  return (bytes / (1024 * 1024)).toFixed(2)
}

// Selector for display text in UI
export const selectDownloadDisplayText = createSelector(selectDownload, (download) => {
  const { loadedBytes, totalBytes, remainingBytes, percent, status } = download

  if (status === 'idle') return ''
  if (status === 'starting') return 'Starting download...'
  if (status === 'error') return `Error: ${download.error}`
  if (status === 'cancelled') return 'Download cancelled'
  if (status === 'success') return 'Download complete'

  const loadedMB = formatBytes(loadedBytes)

  if (totalBytes !== null && remainingBytes !== null) {
    const totalMB = formatBytes(totalBytes)
    const remainingMB = formatBytes(remainingBytes)
    return `${loadedMB} MB / ${totalMB} MB (${percent}%) • ${remainingMB} MB remaining`
  }

  return `${loadedMB} MB downloaded`
})
